import type { LocalOption } from '@/i18n/types';
import enUS from './en-US';
import zhCN from './zh-CN';

// 项目中支持的语言选项
export const resources = {
  'zh-CN': zhCN,
  'en-US': enUS,
} as const;

export type WebLocale = keyof typeof resources;
const WEB_LOCALES = Object.keys(resources) as WebLocale[];

// 语言资源类型
export type Resources = (typeof resources)['zh-CN'];

// 默认命名空间
export const defaultNS = 'common';

// 项目中支持的语言选项
const localeLabelMap = {
  'zh-CN': '🇨🇳 简体中文',
  'en-US': '🇺🇸 English',
} as const satisfies Record<WebLocale, string>;

export const localeOptions: LocalOption[] = WEB_LOCALES.map((value) => ({
  value,
  label: localeLabelMap[value],
}));

// 生成 "ns:key" 格式的所有合法国际化 key，与 t() 函数保持一致
export type I18nKey = {
  [NS in keyof Resources]: `${NS & string}:${Extract<keyof Resources[NS], string>}`;
}[keyof Resources];
